import { useUser } from '../../contexts/UserContext'
import { KnowledgeBaseTab } from '../../components/RAG/Tabs/KnowledgeBaseTab'

export function KnowledgeBasePage() {
    const { session } = useUser()

    return <KnowledgeBaseTab session={session} />
}
